import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from '@/components/ui/select';
import { EOS_TODO_PRIORITIES, EOS_TODO_PRIORITY_LABELS, type EosTodoPriority } from '../types';

export interface TodoFormState {
  title: string;
  description: string;
  ownerId: string;
  teamId: string;
  dueDate: string;
  priority: EosTodoPriority;
}

interface Props {
  value: TodoFormState;
  onChange: (next: TodoFormState) => void;
  ownerOptions: { id: string; label: string }[];
  teamOptions: { id: string; label: string }[];
}

export function TodoFormFields({ value, onChange, ownerOptions, teamOptions }: Props) {
  return (
    <div className="space-y-3">
      <div>
        <Label htmlFor="title">Title</Label>
        <Input
          id="title"
          value={value.title}
          onChange={(e) => onChange({ ...value, title: e.target.value })}
          placeholder="What's the 7-day commitment?"
        />
      </div>

      <div>
        <Label htmlFor="owner">Owner</Label>
        <Select value={value.ownerId} onValueChange={(v) => onChange({ ...value, ownerId: v })}>
          <SelectTrigger id="owner"><SelectValue placeholder="Pick an owner" /></SelectTrigger>
          <SelectContent>
            {ownerOptions.map(o => <SelectItem key={o.id} value={o.id}>{o.label}</SelectItem>)}
          </SelectContent>
        </Select>
      </div>

      <div>
        <Label htmlFor="team">Team (optional)</Label>
        <Select
          value={value.teamId || 'none'}
          onValueChange={(v) => onChange({ ...value, teamId: v === 'none' ? '' : v })}
        >
          <SelectTrigger id="team"><SelectValue /></SelectTrigger>
          <SelectContent>
            <SelectItem value="none">— No team —</SelectItem>
            {teamOptions.map(t => <SelectItem key={t.id} value={t.id}>{t.label}</SelectItem>)}
          </SelectContent>
        </Select>
      </div>

      <div className="grid grid-cols-2 gap-3">
        <div>
          <Label htmlFor="due">Due date</Label>
          <Input
            id="due"
            type="date"
            value={value.dueDate}
            onChange={(e) => onChange({ ...value, dueDate: e.target.value })}
          />
        </div>
        <div>
          <Label htmlFor="priority">Priority</Label>
          <Select value={value.priority} onValueChange={(v) => onChange({ ...value, priority: v as EosTodoPriority })}>
            <SelectTrigger id="priority"><SelectValue /></SelectTrigger>
            <SelectContent>
              {EOS_TODO_PRIORITIES.map(p => (
                <SelectItem key={p} value={p}>{EOS_TODO_PRIORITY_LABELS[p]}</SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
      </div>

      <div>
        <Label htmlFor="description">Description</Label>
        <Textarea
          id="description"
          value={value.description}
          onChange={(e) => onChange({ ...value, description: e.target.value })}
          placeholder="Optional context or acceptance criteria"
          rows={4}
        />
      </div>
    </div>
  );
}
